import Planning from '../common/planning.jsx';

function PlanningPage() {
  return (
    <div>
      <Planning />
    </div>
  );
}

export default PlanningPage;